import styled, { useTheme } from "styled-components";
import { CreateFormTheme } from "../../utils/themes";


export const Button = styled.button<{
  $variant?: "add" | "customize" | "newRecord" | "cancel" | "preview" | "share" | "colored" | "normal" | "customButton";
  height?: string;
  btnBg?: string;
  borderColor?: string;
  color?: string;
  fontSize?: string;
  fontFamily?: string;
  theme?: any;
  width?: string
  radius?: string
  textColor?: string
  disabled?: boolean
  btnPadding?: string
  textPosition?: "center" | "start" | "end";
  fontWeight?: string;
  gap?: string;
}>`
  padding: ${CreateFormTheme.spacing.sm} ${CreateFormTheme.spacing.sm};
  border-radius: ${({ radius }) => radius || '3px'};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  border: 1px solid transparent;
  font-family: "Raleway", sans-serif;
  font-weight: ${({ fontWeight }) => fontWeight || 500};
  font-size: ${({ fontSize }) => fontSize || "14px"};
  font-family: ${({ fontFamily }) => fontFamily || "Raleway, sans-serif"};
  height: ${({ height }) => height || '42px'};
  display: flex;
  align-items: center;
  gap: ${({ gap }) => gap || '8px'};
  justify-content: ${({ textPosition = 'center' }) => textPosition};
  min-width: ${({ width }) => {
    if (!width) return "100px";
    const numeric = parseInt(width, 10);
    return numeric < 100 ? width : "100px";
  }};
  width: ${({ width }) => width};

  ${({ $variant = "add", theme, btnBg, borderColor, color, width, btnPadding }: {
    $variant?: "add" | "customize" | "newRecord" | "cancel" | "preview" | "share" | "colored" | "normal" | "customButton";
    theme: any;
    btnBg?: string;
    borderColor?: string;
    color?: string;
    width?: string;
    btnPadding?: string
  }) => {
    switch ($variant) {
      case "customize":
        return `
          background: ${theme.CorporateTheme.colors.buttonOrange};
          color: white;
          border-color: ${theme.CorporateTheme.colors.buttonOrange};
        `;

      case "newRecord":
        return `
          background: ${theme?.CreateFormTheme?.colors?.primaryBtn};
          width: 100%;
          color: ${theme?.CreateFormTheme?.colors?.background};
          &:hover {
            background: ${theme?.CreateFormTheme?.colors?.hoverPrimary};
          }
        `;
      case "preview":
        return `
          background: ${theme.CorporateTheme.colors.background};
          color: ${theme.CreateFormTheme.colors.textSecondary};
          border: 1px solid ${theme.CreateFormTheme.colors.inputBorders};
          &:hover {
            background: ${theme.CreateFormTheme.colors.hoverCancel};
          }
        `;
      case "share":
        return `
          background: ${theme.CreateFormTheme.colors.count};
          color: white;
          &:hover {
            background: ${theme.CreateFormTheme.colors.count};
          }
        `;
      case "cancel":
        return `
          background: ${theme.CorporateTheme.colors.background};
          color: ${theme.CreateFormTheme.colors.textSecondary};
          border: 1px solid ${theme.CreateFormTheme.colors.inputBorders};
          &:hover {
            background: ${theme.CreateFormTheme.colors.hoverCancel};
          }
        `;
      case "normal":
        return `
          background: transparent;
          color: ${theme.CreateFormTheme.colors.textSecondary};
          border: none;
          &:hover {
            background: ${theme.CreateFormTheme.colors.hoverCancel};
          }
        `;
      case "customButton":
        return `
          background: ${btnBg || theme?.CorporateTheme?.colors?.headerBG} !important;
          color: ${color || theme?.CorporateTheme?.colors?.textSecondary} !important;
          border: 1px solid ${borderColor || theme?.CreateFormTheme?.colors?.border};
          padding: ${btnPadding ? btnPadding : '5px 15px !important'};
          &:hover {
            background: ${theme?.CreateFormTheme?.colors?.hoverCancel};
          }
        `;
      default:
        return `
          background: ${theme?.CreateFormTheme?.colors?.primaryBtn};
           padding: 0px 20px !important;
          color: ${theme?.CorporateTheme?.colors?.background};
                    &:hover {
            background: ${theme?.CreateFormTheme?.colors?.hoverPrimary};
          }
        `;
    }
  }}
  &:disabled {
    background: ${({ theme }) => theme?.CreateFormTheme?.colors?.inputBorders || '#d9d9d9'};
    color: ${({ theme }) => theme?.CorporateTheme?.colors?.textSecondary || '#888'};
    opacity: 0.5;
    cursor: not-allowed;
    border: 1px solid ${({ theme }) => theme?.CreateFormTheme?.colors?.inputBorders || '#d9d9d9'};
    // & svg path{
    //   stroke: ${({ theme }) => theme?.CorporateTheme?.colors?.textSecondary || '#888'};
    // }
  }
`;
